import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../_Sections/SectionDetails';
import SectionGallery from '../_Sections/SectionGallery';
import SectionDropship from '../_Sections/SectionDropship';
import SectionPairings from '../_Sections/SectionPairings';
import SectionBranding from '../_Sections/SectionBranding';
import SectionSizes from '../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../_Sections/SectionPricing';
import tKey from '../../Common/Utils/tKey';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';
import ProductSEO from '../_Sections/ProductSEO';

const PRODUCT_ID = 60;
const VIEW_PRODUCT_ID = 32;

export default function BabyLeggingsPage() {
  const [t] = useTranslation('page/products/youth-leggings');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Youth Leggings | Products')}
      description={t('Design and create your own custom printed Youth Leggings featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#ebabd5"
      bgStyle={{
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '50%',
      }}
      tag={t('The all-over print')}
      title={t('Youth Leggings')}
      text={t('Let kids move freely in custom all-over print leggings made on-demand in Montreal. Printed on ultrasoft Luxeform fabric with a foldover waistband, they offer a comfortable, flexible fit. Available in sizes 4–12, the vibrant, fade-proof prints will keep up with every adventure.')}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/youth-leggings/banner-1-' + locale + '.png')}
      alt={t('Picture of Youth Leggings')}
      details={[
        {
          img: require('@resources/img/pages/products/youth-leggings/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Classic fit with foldover elastic waistband.'),
        },
        {
          img: require('@resources/img/pages/products/youth-leggings/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/youth-leggings/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Full length and available in sizing from 4 to 12 years old.'),
        },
        {
          img: require('@resources/img/pages/products/youth-leggings/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/youth-leggings/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    <SectionGallery images={[
      require('@resources/img/pages/products/youth-leggings/gallery_0.jpg'),
      require('@resources/img/pages/products/youth-leggings/gallery_1.jpg'),
      require('@resources/img/pages/products/youth-leggings/gallery_2.jpg'),
      require('@resources/img/pages/products/youth-leggings/gallery_3.jpg'),
      require('@resources/img/pages/products/youth-leggings/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Youth <br/>Leggings <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Youth Leggings! At prices designed for reselling, Youth Leggings made on demand meet the needs of sellers who prefer not to stock inventory.. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing productId={PRODUCT_ID} />

    <SectionSizes
      productId={PRODUCT_ID}
      title={t('Youth Leggings Sizing')}
      text={t('There may be some variations in product measurements within or between orders. Each garment is individually cut and sewn which can lead to minor differences in measurements. In order : 4-5 years, 6-7 year, 8-9 years, 10-12 years')}
    >
      <img
        src={require('@resources/img/pages/products/youth-leggings/size-4-5.png')}
        style={{
          marginRight: 0,
          maxWidth: '270px',
        }}
      />
      <img
        src={require('@resources/img/pages/products/youth-leggings/size-6-7.png')}
        style={{
          marginRight: 0,
          maxWidth: '260px',
        }}
      />
      <img
        src={require('@resources/img/pages/products/youth-leggings/size-8-9.png')}
        style={{
          marginRight: 0,
          maxWidth: '290px',
        }}
      />
      <img
        src={require('@resources/img/pages/products/youth-leggings/size-10-12.png')}
        style={{
          marginRight: 0,
          maxWidth: '280px',
        }}
      />
    </SectionSizes>

    <SectionBranding
      hasLabel
      title={t('Brand your Youth Leggings')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Youth Leggings with these great products to create your own unique styles.')}
      productSlugs={['baby-leggings', 'beanies-youth', 'headband']}
    />
  </div>
}